// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"509e4cad","453":"71982e39","455":"6b155922","977":"bb93f1c2"}[chunkId] + ".chunk.js";
};